/* OFFER DATA */
export const GET_OFFER_DATA = "GET_OFFER_DATA"
export const SET_OFFER_DATA = "SET_OFFER_DATA"

/* OFFER TRACKERS */
export const GET_TRACKERS = "GET_TRACKERS"
export const SET_TRACKERS = "SET_TRACKERS"
export const POST_OFFER = "POST_OFFER"
export const SET_OFFER = "SET_OFFER"
export const UPDATE_OFFER = "UPDATE_OFFER"
export const DELETE_OFFER = "DELETE_OFFER"

export const GET_OFFER_BY_ID = "GET_OFFER_BY_ID"

/* OFFER HISTORY DATA */
export const GET_OFFER_HISTORY_LIST = "GET_OFFER_HISTORY_LIST"
export const SET_OFFER_HISTORY_LIST = "SET_OFFER_HISTORY_LIST"
export const ADD_OFFER_HISTORY = "ADD_OFFER_HISTORY"
export const DELETE_OFFER_HISTORY = "DELETE_OFFER_HISTORY"
export const SET_OFFER_HISTORY_ITEM = "SET_OFFER_HISTORY_ITEM"

/* OFFER TRACKER DATA */
export const GET_OFFER_TRACKER_LIST = "GET_OFFER_TRACKER_LIST"
export const SET_OFFER_TRACKER_LIST = "SET_OFFER_TRACKER_LIST"

/* OFFER TRACKER ACTIONS */
export const SHOW_OFFER_TRACKER_LIST_LOADER = "SHOW_OFFER_TRACKER_LIST_LOADER"
export const HIDE_OFFER_TRACKER_LIST_LOADER = "HIDE_OFFER_TRACKER_LIST_LOADER"
export const ADD_OFFER_TRACKER = "ADD_OFFER_TRACKER"
export const DELETE_OFFER_TRACKER = "DELETE_OFFER_TRACKER"

/* OFFER TRACKER PROFILE DATA */
export const GET_TRACKER_OFFER_PROFILE = "GET_TRACKER_OFFER_PROFILE"
export const SET_TRACKER_OFFER_PROFILE = "SET_TRACKER_OFFER_PROFILE"
export const UPDATE_TRACKER_OFFER_PROFILE = "UPDATE_TRACKER_OFFER_PROFILE"
export const SET_ERROR_TRACKER_OFFER_PROFILE = "SET_ERROR_TRACKER_OFFER_PROFILE"
export const OFFER_STATE_INIT = "OFFER_STATE_INIT"

/* GET OFFERS */
export const GET_OFFERS = "GET_OFFERS";
export const SET_OFFERS = "SET_OFFERS";

/* ALL OFFERS FOR CLIENT */
export const GET_OFFERS_FOR_CLIENT = "GET_OFFERS_FOR_CLIENT"
export const SET_OFFERS_FOR_CLIENT = "SET_OFFERS_FOR_CLIENT"
export const SET_OFFERS_RENT_FOR_CLIENT = "SET_OFFERS_RENT_FOR_CLIENT"

/* LOADER */
export const SHOW_OFFER_DATA_LOADER = "SHOW_OFFER_DATA_LOADER"
export const HIDE_OFFER_DATA_LOADER = "HIDE_OFFER_DATA_LOADER"
export const SHOW_TRACKERS_LOADER = "SHOW_TRACKERS_LOADER"
export const HIDE_TRACKERS_LOADER = "HIDE_TRACKERS_LOADER"
export const SHOW_OFFER_LOADER = "SHOW_OFFER_LOADER"
export const HIDE_OFFER_LOADER = "HIDE_OFFER_LOADER"

/* TIMELESS TOOLS */
export const UPDATE_OFFER_STATUS = "UPDATE_OFFER_STATUS";

/* OFFER WITH REGULAR MATCHING */
export const GET_OFFERS_WITH_REGULAR_MATCHING = "GET_OFFERS_WITH_REGULAR_MATCHING"
export const SET_OFFERS_WITH_REGULAR_MATCHING = "SET_OFFERS_WITH_REGULAR_MATCHING"
export const HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER = "HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER"
export const SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER = "SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER"

export const GET_OFFERS_BY_CONTRACT = "GET_OFFERS_BY_CONTRACT"
export const SET_OFFERS_BY_CONTRACT = "SET_OFFERS_BY_CONTRACT"
export const OFFERS_BY_CONTRACT_LOADER = "OFFERS_BY_CONTRACT_LOADER"